import "../../../chunk-D57E6H3M.mjs";

// src/components/primitive/Text/Text.tsx
import { jsx } from "react/jsx-runtime";
function Text({
  variant = "body",
  as: Component = "span",
  italic = false,
  className = "",
  children,
  ...rest
}) {
  const variantClass = `buyscout-text--${variant}`;
  const italicClass = italic ? "buyscout-text--italic" : "";
  const combinedClass = `buyscout-text ${variantClass} ${italicClass} ${className}`.trim().replace(/\s+/g, " ");
  return /* @__PURE__ */ jsx(Component, { className: combinedClass, ...rest, children });
}
Text.displayName = "Text";
export {
  Text
};
//# sourceMappingURL=Text.mjs.map